export default __webpack_public_path__ + "static/media/cardImgExample.b6287718.jpg";